// extracted by mini-css-extract-plugin
export default {"modal":"modal-tj9Fb","body":"body-U2axF","headerText":"headerText-e9eCt","bodyText":"bodyText-ckJ_C","button":"button-E61m2"};